import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import { 
    IsXsDownScreen
} from '../../../business-components/Service/GlobalService'

import {
    GridContainer,
    GridItem1,
    GridItem2,
    GridItem3xs1,
    GridItem3xs6,
    GridItem4,
    GridItem4xs6,
    GridItem4xs10,
    GridItem6,
    GridItem6xs8,
    GridItem6xs10,
    GridItem10,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDividerElementos,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    TextFieldNumberSelectDestaque,
} from '../../../business-components/TextField/TextFieldSelect'

//import {
//    InformacoesOpcionaisNaoAfetamCalculo
//} from '../cliente-form/ClienteComp'

import {
    dadosCompletosConjuge,
} from '../cliente-form/ClienteService'

import {
    TipoPatrimonioImobilizado,
    HelpTipoPatrimonioImobilizado,
    IconButtonClearEntradaDadosPatrimonioImobilizado,
    TipoFinalidadePatrimonioImobilizado,
    Valor,
    Alugado,
    ValorAluguel,
    PercPatrimonioImobilizadoCliente,
    PercPatrimonioImobilizadoConjuge,
    NaoInventariar,
    HelpNaoInventariar,
    UfItcmd,
    PercDespesasAdvocaticias,
    PercCustasJudiciais,
    PercInventarioItcmd,
    ConsiderarGarantiaMorteInvalidezCliente,
    ConsiderarGarantiaMorteInvalidezConjuge,
    HelpConsiderarGarantiaMorteInvalidez,
    //TipoImovel,
    ValorContabil,
    ValorCompra,
    DataCompra,
    TipoEmpresa,
    TipoRegimeTributarioEmpresa,
    TipoPlanejamentoSucessorio,
    DescricaoOutros,
    HelpDescricaoOutros,
    Observacao,
} from './GarantiasCompPatrimonioImobilizado'



const GarantiasFormPatrimonioImobilizadoItem = ({ values, handleChange, setFieldValue, arrayHelpers, tipoPatrimonioImobilizadoSelecionado,
    item, ind, simplificado }) => {

    const isXsDownScreen = IsXsDownScreen()



    return (
        <CardGridEntradaDados>
            <CardGridDivHeaderEntradaDados>
                <GridContainer>
                    <GridItem6xs8>
                        <TipoPatrimonioImobilizado
                            TextFieldNumberSelectTipoPatrimonioImobilizado={
                                TextFieldNumberSelectDestaque
                            }
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem6xs8>
                    <GridItem2>
                        <HelpTipoPatrimonioImobilizado
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                            tipoPatrimonioImobilizadoSelecionado={tipoPatrimonioImobilizadoSelecionado}
                        />
                    </GridItem2>
                    <GridItem3xs1 />
                    <GridItem1>
                        <IconButtonClearEntradaDadosPatrimonioImobilizado
                            values={values}
                            setFieldValue={setFieldValue}
                            item={item}
                            ind={ind}
                            arrayHelpers={arrayHelpers}
                            simplificado={simplificado}
                        />
                    </GridItem1>
                </GridContainer>
            </CardGridDivHeaderEntradaDados>

            <CardGridDivBodyEntradaDados
                style={{
                    display: 
                        item.tipoPatrimonioImobilizado
                            ? "block"
                            : "none"
                }} 
            >
                <GridContainer>
                    <GridItem4xs6>
                        <Valor
                            values={values}
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem4xs6>
                    {tipoPatrimonioImobilizadoSelecionado.informaAluguel === "S" && (
                        <>
                            {isXsDownScreen && (
                                <GridItem6/>
                            )}
                            <GridItem3xs6>
                                <Alugado
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem3xs6>
                        </>
                    )}
                    {tipoPatrimonioImobilizadoSelecionado.informaAluguel === "S" && !item.alugado && (
                        <GridItem4/>
                    )}
                    {tipoPatrimonioImobilizadoSelecionado.informaAluguel === "S" && item.alugado && (
                        <GridItem4xs6>
                            <ValorAluguel
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem4xs6>
                    )}
                    {item.familiar === HARDCODE.idFamiliarCasal && (
                        <>
                            <GridItem4xs6>
                                <PercPatrimonioImobilizadoCliente
                                    values={values}
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs6>
                            <GridItem4xs6>
                                <PercPatrimonioImobilizadoConjuge
                                    values={values}
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs6>
                        </>
                    )}
                </GridContainer>
                
                <GridContainer>
                    <GridItem10>
                        <DescricaoOutros
                            item={item}
                            ind={ind}
                            handleChange={handleChange} 
                        />
                    </GridItem10>
                    <GridItem2>
                        <HelpDescricaoOutros/>
                    </GridItem2>
                </GridContainer>

                {/*tipoPatrimonioImobilizadoSelecionado.informaTipoFinalidadePatrimonioImobilizado === "S" && (*/}
                <GridContainer>
                    <GridItem6>
                        <TipoFinalidadePatrimonioImobilizado
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem6>
                </GridContainer>
                {/*})*/}

                <GridContainer>
                    <GridItem6>
                        <ValorContabil
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem6>
                </GridContainer>

                <GridContainer>
                    {/*item.valorCompra && (*/}
                    <GridItem6>
                        <DataCompra
                            item={item}
                            ind={ind}
                            setFieldValue={setFieldValue}
                        />
                    </GridItem6>
                    {/*)}*/}

                    <GridItem6>
                        <ValorCompra
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem6>
                </GridContainer>

                {tipoPatrimonioImobilizadoSelecionado.informaTipoEmpresaTipoRegimeTributario === "S" && (
                    <GridContainer>
                        <GridItem12>
                            <TipoEmpresa
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem12>

                         <GridItem12>
                            <TipoRegimeTributarioEmpresa
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem12>
                    </GridContainer>
                )}

                <GridContainer>
                    <GridItem6>
                        <TipoPlanejamentoSucessorio
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem6>
                </GridContainer>

                <CardGridDividerElementos/>

                <GridContainer>
                    <GridItem4xs10>
                        <NaoInventariar
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem4xs10>
                    <GridItem2>
                        <HelpNaoInventariar/>
                    </GridItem2>
                    {tipoPatrimonioImobilizadoSelecionado.informaUfItcmd === "S" &&
                    (!item.naoInventariar || item.ufItcmd) && (
                        <GridItem6xs10>
                            <UfItcmd
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem6xs10>
                    )}
                </GridContainer>

                <GridContainer>
                    {item.ufItcmd !== HARDCODE.ufExterior && (
                        <>
                            <GridItem4xs10>
                                <PercDespesasAdvocaticias
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs10>
                            <GridItem4xs10>
                                <PercCustasJudiciais
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs10>
                        </>
                    )}
                    <GridItem4xs10>
                        <PercInventarioItcmd
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem4xs10>
                </GridContainer>
            
                {(item.familiar === HARDCODE.idFamiliarCliente ||
                item.familiar === HARDCODE.idFamiliarConjuge ||
                item.familiar === HARDCODE.idFamiliarCasal) && (
                    <GridContainer>
                        <GridItem10>
                            <ConsiderarGarantiaMorteInvalidezCliente
                                values={values}
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem10>
                        
                        {dadosCompletosConjuge(values, true) && (
                            <GridItem10>
                                <ConsiderarGarantiaMorteInvalidezConjuge
                                    values={values}
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem10>
                        )}
                        <GridItem1>
                            <HelpConsiderarGarantiaMorteInvalidez/>
                        </GridItem1>
                    </GridContainer>
                )}
              
                {/*
                <CardGridDividerElementos/>

                <InformacoesOpcionaisNaoAfetamCalculo />

                {tipoPatrimonioImobilizadoSelecionado.informaTipoImovel === "S" && (
                    <GridContainer>
                        <GridItem6xs10>
                            <TipoImovel
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem6xs10>
                    </GridContainer>
                )}
                */}

                <CardGridDividerElementos/>

                <GridContainer>
                    <GridItem12>
                        <Observacao
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem12>
                </GridContainer>
            </CardGridDivBodyEntradaDados>
        </CardGridEntradaDados>
    )
}

export default GarantiasFormPatrimonioImobilizadoItem